import { defineMessages } from 'react-intl';

export const messages: {
	selectedStateColor: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	textColor: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	textTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	textTitle: {
		id: 'company-hub.links-menu-extension.text.title',
		defaultMessage: 'Text',
		description:
			'Bolded heading text shown at the top of the text configuration section in the links menu extension styles tab config panel.',
	},
	textColor: {
		id: 'company-hub.links-menu-extension.text.color',
		defaultMessage: 'Text color',
		description: 'Text labeling a customization option for text colors',
	},
	selectedStateColor: {
		id: 'company-hub.links-menu-extension.selected.state.color',
		defaultMessage: 'Selected state color',
		description: 'Text labeling a customization option for selected state colors',
	},
});
